import React, { useEffect, useState } from 'react';
import { FiX, FiPackage, FiHash, FiMaximize2 } from 'react-icons/fi';
import apiCall from '../helper/apiCall';

const CartItemsModal = ({ show, onClose, cartId, cartNumber }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [previewImage, setPreviewImage] = useState(null); // For the pop-up

    const BASE_URL = "https://admin.kanthasri.com"; // Add your base URL if needed

    useEffect(() => {
        if (show && cartId) {
            const fetchItems = async () => {
                setLoading(true);
                const response = await apiCall("getCartItems", { cartId });
                if (response?.success) setItems(response.data);
                setLoading(false);
            };
            fetchItems();
        }
    }, [show, cartId]);

    if (!show) return null;

    return (
        <>
            {/* Main Modal */}
            <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
                <div className="bg-white rounded-3xl w-full max-w-3xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">
                    <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50">
                        <div>
                            <h2 className="text-xl font-bold text-slate-800">Items in {cartNumber || `#${cartId}`}</h2>
                        </div>
                        <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full transition-colors">
                            <FiX size={20} className="text-slate-500" />
                        </button>
                    </div>

                    <div className="p-6 overflow-y-auto">
                        {loading ? (
                            <div className="text-center py-10 font-medium text-slate-500">Loading items...</div>
                        ) : (
                            <div className="space-y-4">
                                {items.map((item) => {
                                    // Extract the first image thumbnail if available
                                    const firstImage = item.product_item_images?.[0];
                                    const thumbSrc = firstImage?.thumbnail;
                                    const fullSrc = BASE_URL + firstImage?.main || firstImage?.zoom;

                                    return (
                                        <div key={item.cart_item_id} className="flex items-center justify-between p-3 border border-slate-100 rounded-2xl bg-white shadow-sm hover:border-blue-200 transition-all">
                                            <div className="flex items-center gap-4">
                                                {/* Image Thumbnail with Hover Effect */}
                                                <div 
                                                    className="relative w-16 h-16 rounded-xl overflow-hidden bg-slate-100 cursor-zoom-in group"
                                                    onClick={() => setPreviewImage(fullSrc)}
                                                >
                                                    {thumbSrc ? (
                                                        <img 
                                                            src={thumbSrc} 
                                                            alt="Product" 
                                                            className="w-full h-full object-cover group-hover:scale-110 transition-transform" 
                                                        />
                                                    ) : (
                                                        <FiPackage className="w-full h-full p-4 text-slate-300" />
                                                    )}
                                                    <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
                                                        <FiMaximize2 className="text-white" />
                                                    </div>
                                                </div>

                                                <div>
                                                    <h4 className="font-bold text-slate-800 leading-tight">{item.product_name}</h4>
                                                    <div className="flex gap-3 mt-1.5">
                                                        <span className="text-[11px] font-bold px-2 py-0.5 bg-slate-100 text-slate-500 rounded-md flex items-center gap-1">
                                                            <FiHash size={10}/> QTY: {item.quantity}
                                                        </span>
                                                        <span className="text-[11px] font-bold px-2 py-0.5 bg-blue-50 text-blue-600 rounded-md">
                                                            ID: {item.product_item_id}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-right pr-2">
                                                <div className="text-lg font-black text-slate-900">₹{item.sell_price_at_addition}</div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    <div className="p-4 bg-slate-50 border-t border-slate-100 flex justify-end">
                        <button onClick={onClose} className="px-8 py-2.5 bg-slate-900 text-white rounded-xl font-bold hover:bg-slate-800 transition-all shadow-lg shadow-slate-200">
                            Close Details
                        </button>
                    </div>
                </div>
            </div>

            {/* Image Pop-up (Light-box) */}
            {previewImage && (
                <div 
                    className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4 animate-in fade-in duration-200"
                    onClick={() => setPreviewImage(null)}
                >
                    <button className="absolute top-6 right-6 text-white p-2 hover:bg-white/10 rounded-full">
                        <FiX size={32} />
                    </button>
                    <img 
                        src={previewImage} 
                        className="max-w-full max-h-full rounded-lg shadow-2xl object-contain animate-in zoom-in-95 duration-300" 
                        alt="Preview" 
                    />
                </div>
            )}
        </>
    );
};

export default CartItemsModal;